// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__Rakxi","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1BE9q","obliqueLine":"membershipbadge_obliqueLine__2-k6k"};